export const environment = {
  production: true,
  // apiUrl: 'https://salientcleaningandhealthcareservices.org/',
  // apiUrl: (location.hostname === "localhost" || location.hostname === "127.0.0.1") ? 'https://jrfarmsafrica.com' : 'https://api.cms.phynixmedia.co.uk',
  // apiUrl: (location.hostname === "localhost" || location.hostname === "127.0.0.1") ? 'https://aventura-staging.phynixmedia.co.uk' : 'https://api.cms.phynixmedia.co.uk',
  apiUrl: determineApiUrl(),
  socket: ""
};


function determineApiUrl(): string {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return "http://localhost:8000"; //backend api to my laravel on the local host

  }
  else {
    /**
            * //Because we do not know the api end point to call if
            *  we are not runnin on local host
            * then we need to look into the url to get the address to call 
            */

    let hostname = document.location.hostname
    return `https://${hostname}`

  }
}

// https://staging.jrfarmsafrica.com